import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { partialReducer, SET_DEALER_EVENTS } from '@/store/actions/events';

export default (state, action) => {
    switch (action.type) {
        case AUTH_INVALIDATE:
        case SET_DEALER_EVENTS:
            return { ...state, events: action.data };
        default:
            return partialReducer(state, action);
    }
};
